import { ActivatedRoute, NavigationExtras } from '@angular/router';

/**
 * Builds a URL with query parameters appended.
 * @param baseUrl - The base URL
 * @param queryParams - Object containing key-value pairs for query parameters
 * @returns The URL with query parameters appended
 */
export function buildUrlWithQueryParams(baseUrl: string, queryParams: Record<string, string> = {}): string {
  try {
    const url = new URL(baseUrl);
    Object.entries(queryParams).forEach(([key, value]) => {
      url.searchParams.set(key, value);
    });
    return url.toString();
  } catch {
    // Fallback for invalid URLs
    const separator = baseUrl.includes('?') ? '&' : '?';
    const params = Object.entries(queryParams)
      .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
      .join('&');
    return params ? `${baseUrl}${separator}${params}` : baseUrl;
  }
}

/**
 * Builds NavigationExtras object based on action configuration.
 * @param action - The action configuration with routing options
 * @param route - The current ActivatedRoute for relative navigation
 * @returns NavigationExtras object for router.navigate()
 */
export function buildNavigationExtras(
  action: { relativeRoute?: boolean; queryParams?: Record<string, string> },
  route?: ActivatedRoute,
): NavigationExtras {
  const navigationExtras: NavigationExtras = {};

  if (action.relativeRoute && route) {
    navigationExtras.relativeTo = route;
  }

  if (action.queryParams) {
    navigationExtras.queryParams = action.queryParams;
  }

  return navigationExtras;
}
